export default {
  POPULAR_VALUES: '国産車',
  UNPOPULAR_VALUES: '輸入車',
};
